module.exports = __webpack_public_path__ + "img/service-ico.e87f05a7.png";